import React from 'react'
import { BasicDropdown } from '..'
import { SelectCheckbox } from '../dashboard-form'
import { useSystem } from '../../features/system/hook'
import { useSelector } from 'react-redux'

const FormSystem = ({initialForm, handleMulti}) => {
  const {
    approachOptions,
    issueOptions,
    organizationTypeOptions,
  } = useSystem()

  const [form, setForm] = React.useState({})
  const language = useSelector(state => state.system.language)
  const translation = useSelector(state => state.translation.data)

  React.useEffect(() => {
    if(initialForm){
      setForm(initialForm)
    }
  }, [initialForm])

  return form ? (
    <div className="mb-8">
      <p className="font-bold text-sm mb-4">
        {translation.SEARCH.type[language.name]}
      </p>
      {
        (organizationTypeOptions && organizationTypeOptions.length > 0) &&
        <BasicDropdown
          multi
          placeholder={translation.ORGANIZATION.singular[language.name]}
          options={organizationTypeOptions}
          value={form.type || []}
          onChange={(e) => handleMulti(e, 'type')}
        />
      }
      {
        (approachOptions && approachOptions.length > 0) &&
        <BasicDropdown
        placeholder={translation.APPROACH.singular[language.name]}
          multi
          options={approachOptions}
          value={form.approach || []}
          onChange={(e) => handleMulti(e, 'approach')}
        />
      }
      {
        (issueOptions && issueOptions.length > 0) &&
        <SelectCheckbox
          className="text-sm"
          options={issueOptions}
          value={form.issue || []}
          placeholder={translation.ISSUE.singular[language.name]}
          onChange={(e) => handleMulti(e, 'issue')}
        />
      }
    </div>
  ) : <div>error</div>
}

export { FormSystem }
